import React from "react";
import { Container } from "reactstrap";
import Wrapper from "components/PublicWrapper";
import { Link } from "react-router-dom";
import brokenGraphic from "components/Images/error-500.svg";

const NotFound = () => (
  <Wrapper>
    <Container className="pt-5 text-center" fluid>
      <div className="error">
        <div className="error__container">
          <img className="error__image" src={brokenGraphic} alt=" " />
          <h1>
            Sorry, we couldn&apos;t find the page you&apos;re looking for.
          </h1>
          <Link to="/" className="btn btn-primary my-5">
            Back to Homepage
          </Link>
        </div>
      </div>
    </Container>
  </Wrapper>
);

export default NotFound;
